<template>
    <!--<div style="height: 100%;">-->
        <!--<resize-observer @notify="onPageResize" />-->
    <router-view></router-view>
    <!--</div>-->
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'loginUser'
            ])
        },
        mounted() {},
        components: {

        },
        methods: {

        }
    }
</script>

<style lang="scss">
    // @import './scss/common.scss';
</style>
